"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axios = exports.request = void 0;
const axios_1 = __importDefault(require("axios"));
exports.axios = axios_1.default;
const utils_1 = require("./utils");
const request_1 = __importStar(require("./request"));
var stringify_1 = require("./json/stringify");
Object.defineProperty(exports, "jsonStringify", { enumerable: true, get: function () { return stringify_1.default; } });
var parse_1 = require("./json/parse");
Object.defineProperty(exports, "jsonParse", { enumerable: true, get: function () { return parse_1.default; } });
var DebounceContext_1 = require("./DebounceContext");
Object.defineProperty(exports, "DebounceContext", { enumerable: true, get: function () { return DebounceContext_1.default; } });
// 仿照 axios 创建实例过程
function createInstance(config = {}) {
    const context = new request_1.Request(config);
    const request = request_1.Request.prototype.request.bind(context);
    utils_1.extend(request, request_1.Request.prototype, context);
    Object.getOwnPropertyNames(request_1.Request.prototype).forEach(key => {
        if (key === 'constructor') {
            return;
        }
        request[key] = request_1.Request.prototype[key].bind(context);
    });
    // copy axios 上的所有实例和静态属性，不绑定 this
    utils_1.extend(request, axios_1.default, undefined, Object.keys(axios_1.default.Axios.prototype));
    // copy 实例属性
    utils_1.extend(request, context);
    request.create = function create(requestConfig) {
        return createInstance(requestConfig);
    };
    return request;
}
const request = createInstance();
exports.request = request;
exports.default = request_1.default;
__exportStar(require("./typing"), exports);
//# sourceMappingURL=index.js.map